import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { DefaultLandingService } from '../services/default-landing.service';

@Injectable({
  providedIn: 'root'
})
export class MobileGuard implements CanActivate {
  constructor(
    private router: Router,
    private defaultLanding: DefaultLandingService
  ) {}

  canActivate(): boolean {
    const home = this.defaultLanding.getHomePath();
    if (home !== 'landing') {
      this.router.navigate(['/' + home]);
      return false;
    }
    return true;
  }
}
